<template>
  <div :class="[outerClass, colSize]">
    <label v-if="label" class="block" :class="{ 'required-label': hasRequiredAttr, [labelClass]: true }"
      :style="labelStyle">{{
        __(label)
      }}</label>
    <Password toggleMask style="width: 100%" inputClass="w-full" feedback :weakLabel="__('Weak')"
      :mediumLabel="__('Medium')" :strongLabel="__('Strong')" :promptLabel="__('Enter password')"
      :disabled="isFormDisabled" :name="fieldName" :validation="validation" :pt="passwordPt" :unstyled="true"
      :class="{ 'required-field': hasRequiredAttr }" v-focus="isFocus" v-model="field" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Password from 'primevue/password';
import { __ } from "@helper/utils";

const props = defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  validation: {
    type: [Array, String],
    default: null,
  },
  label: {
    type: String,
    default: null,
  },
  size: {
    type: String,
    default: null
  },
  isFocus: {
    type: Boolean,
    default: false
  },
  isFormDisabled: {
    type: Boolean,
    default: false
  },
  labelClass: {
    type: String,
    default: null
  },
  labelStyle: {
    type: [Object, String],
    default: null
  },
  inRepeater: {
    type: Boolean,
    default: false
  },
});

const field = defineModel('field');
const validation = ref(Array.isArray(props.validation) ? props.validation : [props.validation]);
const colSize = props?.size ? 'col-' + props.size : 'col';
const hasRequiredAttr = validation.value.includes('required');
const outerClass = ref('field');

const passwordPt = {
  root: {
    class: 'relative w-full'
  },
  pcInputText: {
    root: {
      class: 'w-full rounded-md border px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-black-500/50'
    }
  },
  unmaskIcon: {
    class:
      'absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer select-none'
  },
  maskIcon: {
    class:
      'absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer select-none'
  },
  overlay: {
    class: 'mt-1 rounded-md border border-gray-200 bg-white shadow-lg'
  },
  content: {
    class: 'p-3'
  },
  meter: {
    class: 'h-2 rounded bg-gray-200 overflow-hidden'
  },
  meterLabel: (options) => {
    const strength = options?.state?.meter?.strength;

    return {
      class: [
        'h-full rounded transition-all',
        strength === 'strong'
          ? 'bg-emerald-600'
          : strength === 'medium'
            ? 'bg-amber-500'
            : strength === 'weak'
              ? 'bg-red-500'
              : 'bg-gray-300'
      ]
    }
  },
  meterText: (options) => {
    const strength = options?.state?.meter?.strength;

    return {
      class: [
        'mt-2 text-xs',
        strength === 'strong'
          ? 'text-emerald-700'
          : strength === 'medium'
            ? 'text-amber-700'
            : strength === 'weak'
              ? 'text-red-700'
              : 'text-gray-600'
      ]
    }
  }
}

if (props.inRepeater) {
  outerClass.value = null;
}

</script>

<style lang="scss" scoped></style>
